import { ShiftModalOrderDetailsQuery } from 'types/graphql';
import { ActivityTab } from 'components/ActivityTab/ActivityTab';
import { GeneralTab } from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views/OpenShifts/DetailView/GeneralTab/GeneralTab';

export const DetailViewComponentMap = {
  GeneralTab,
  ActivityTab,
};

export type DetailViewActiveTabType = keyof typeof DetailViewComponentMap;

export interface IDetailViewComponentProps {
  data: ShiftModalOrderDetailsQuery;
  setActiveSubView: (activeSubView: DetailViewActiveTabType) => void;
  activeSubView: DetailViewActiveTabType;
}
